RCDPW.module('RCDPW.validator.rules.myAccount.comment', {
    comment: {
        'required': true,
        rangelength: [1, 500]
    }
});